import React from 'react';

import Speak from '../../components/Speak';

export default function AnswerSpeak() {
  return React.createElement(Speak, null);
}